export default "__VITE_ASSET__BfpKL7Mb__"